import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';
import { PageHeader } from '@/components/layout';
import { Button, Card, CardContent, TableSkeleton } from '@/components/ui';
import { ApiErrorDisplay } from '@/components/features/error';
import { MnoIpRangeList } from '@/components/features/mno-ip-ranges/mno-ip-range-list';
import { IpRangeExportMenu } from '@/components/features/mno-ip-ranges/ip-range-export-menu';
import { useMnoIpRanges, useMnoOperators } from '@/hooks/use-mno-ip-ranges';

/**
 * PM-Lese-Ansicht der MNO-IP-Ranges (Issue #318). Gleiche Liste wie die
 * Platform-Verwaltung, aber read-only (kein Edit/Delete).
 */
export function NetworkCoveragePage() {
  const { t } = useTranslation('mno-ip-ranges');
  const { data: entries, isLoading, error, refetch } = useMnoIpRanges();
  const { data: operators } = useMnoOperators();

  return (
    <div>
      <PageHeader
        title={t('coverage.title')}
        description={t('coverage.description')}
        actions={
          <div className="flex gap-2">
            <IpRangeExportMenu entries={entries ?? []} operators={operators ?? []} />
            <Button variant="outline" size="sm" onClick={() => refetch()}>
              <RefreshCw className="mr-2 h-4 w-4" />
              {t('common:button.refresh')}
            </Button>
          </div>
        }
      />

      {isLoading && (
        <Card>
          <CardContent className="py-6">
            <TableSkeleton rows={4} cols={3} />
          </CardContent>
        </Card>
      )}

      {error && <ApiErrorDisplay error={error} onRetry={() => refetch()} />}

      {!isLoading && !error && entries && (
        <MnoIpRangeList entries={entries} operators={operators ?? []} readOnly />
      )}
    </div>
  );
}
